import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import marked from 'marked'
import classnames from 'classnames'
import './FAQs.scss'
import './Tables.scss'

class FAQs extends PureComponent {
  render () {
    return (
      <div id='faqs' className='faq-wrapper sd-faqs js-only'>
        <div className='container pagefaq-accordion'>
          <h1 className='faq-title' tabIndex='0'>FAQs</h1>
          {
            this.props.faqs.length && this.props.faqs.map((faq, index) => {
              return (
                <div className={classnames('faq-section', {'faq-active': faq.id === this.props.currentFaq})} key={index}>
                  <button className='faq-btn' role='button' id={`faq-btn-${faq.id}`} onClick={(event) => this.props.toggleCurrentFaq(event, faq.id)} tabIndex='0'>
                    {faq.question}
                    <span className='faq-btn-icon' aria-hidden='true' />
                  </button>
                  <div className='faq-content'>
                    <div className='faq-html' dangerouslySetInnerHTML={{__html: marked(faq.answer)}} />
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }
}

FAQs.defaultProps = {
  faqs: []
}

FAQs.propTypes = {
  faqs: PropTypes.array,
  toggleCurrentFaq: PropTypes.func,
  currentFaq: PropTypes.number
}

export default FAQs



// WEBPACK FOOTER //
// ./src/components/FAQs/FAQs.jsx